module.exports = __webpack_public_path__ + "static/assets/fefbb4a5dce8299c6f65f7688cf1c14d.png";